import { StringText } from '../StringText'
import './FieldLabel.scss'

interface FieldLabel {
  name: string
  label?: string
  requirementState?: 'required' | 'optional'
}

export const FieldLabel: React.FC<FieldLabel> = ({
  name,
  label,
  requirementState,
}) => {
  return (
    <div className="field-label">
      <label htmlFor={name} className="field-label__text">
        {label || name}
      </label>
      {requirementState === 'required' && (
        <StringText variant="caption" aria-hidden="true" value="*" />
      )}
    </div>
  )
}
